define(['exports', 'lodash', 'react', 'material-ui', 'material-ui/TimePicker/TimePickerDialog', './Field', 'material-ui/styles/getMuiTheme'], function (exports, _lodash, _react, _materialUi, _TimePickerDialog, _Field, _getMuiTheme) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _lodash2 = _interopRequireDefault(_lodash);

  var _react2 = _interopRequireDefault(_react);

  var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);

  var _Field2 = _interopRequireDefault(_Field);

  var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var emptyTime = new Date();
  emptyTime.setHours(0);
  emptyTime.setMinutes(0);
  emptyTime.setSeconds(0);
  emptyTime.setMilliseconds(0);

  var TimePicker = function (_MaterialTimePicker) {
    _inherits(TimePicker, _MaterialTimePicker);

    function TimePicker(props) {
      _classCallCheck(this, TimePicker);

      var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

      _this.state = {
        time: props.defaultTime || emptyTime,
        dialogTime: new Date(),
        muiTheme: (0, _getMuiTheme2.default)(props.Theme.mui)
      };
      return _this;
    }

    _createClass(TimePicker, [{
      key: 'getInitialState',
      value: function getInitialState() {
        return this.state;
      }
    }, {
      key: '_customHandleInputTouchTap',
      value: function _customHandleInputTouchTap() {
        if (!this.props.disabled) {
          _get(TimePicker.prototype.__proto__ || Object.getPrototypeOf(TimePicker.prototype), 'openDialog', this).call(this);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            autoOk = _props.autoOk,
            format = _props.format,
            onFocus = _props.onFocus,
            onTouchTap = _props.onTouchTap,
            onShow = _props.onShow,
            onDismiss = _props.onDismiss,
            style = _props.style,
            textFieldStyle = _props.textFieldStyle,
            hintText = _props.hintText;
        var time = this.state.time;

        var defaultText = null;
        var value = null;
        if (time === emptyTime) {
          defaultText = hintText;
        } else {
          value = _get(TimePicker.prototype.__proto__ || Object.getPrototypeOf(TimePicker.prototype), 'formatTime', this).call(this, time);
        }

        return _react2.default.createElement(
          'div',
          { style: _get(TimePicker.prototype.__proto__ || Object.getPrototypeOf(TimePicker.prototype), 'prepareStyles', this).call(this, style) },
          _react2.default.createElement(_Field2.default, {
            className: 'col col-5 date-time-picker h5 light',
            style: textFieldStyle,
            disabled: this.props.disabled,
            ref: 'input',
            hintText: defaultText,
            value: value,
            onFocus: _get(TimePicker.prototype.__proto__ || Object.getPrototypeOf(TimePicker.prototype), '_handleInputFocus', this),
            onTouchTap: this._customHandleInputTouchTap
          }),
          _react2.default.createElement(_TimePickerDialog2.default, {
            ref: 'dialogWindow',
            initialTime: this.state.dialogTime,
            onAccept: _get(TimePicker.prototype.__proto__ || Object.getPrototypeOf(TimePicker.prototype), '_handleDialogAccept', this).bind(this),
            onShow: onShow,
            onDismiss: onDismiss,
            format: format,
            autoOk: autoOk
          })
        );
      }
    }]);

    return TimePicker;
  }(_materialUi.TimePicker);

  exports.default = TimePicker;


  TimePicker.propTypes = {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/TimePicker.js
// module id = 1165
// module chunks = 0